import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  // Send the httpOnly session cookie with every request — this is how we
  // authenticate now. Tokens are never stored on the client side, so XSS
  // bugs can't steal a session.
  withCredentials: true,
  // Generous timeout so large mobile-photo uploads (10–25MB over slow networks)
  // don't fail with a vague "Network Error". 90s is plenty for any photo size we accept.
  timeout: 90000,
});

export default api;
export { BACKEND_URL };

// Resolves a server-relative URL into a fully-qualified one. Used for image src
// where the backend stores e.g. "/api/uploads/foo.png".
export const resolveUrl = (url) => {
  if (!url) return '';
  if (/^(https?:|data:|blob:)/i.test(url)) return url;
  if (url.startsWith('/api/') || url.startsWith('/uploads/')) return `${BACKEND_URL}${url}`;
  return url;
};
